module.exports = __webpack_public_path__ + "img/feedback-banner.b2e9013c.png";